
<template>
    <div
        class="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8"
    >
        <div v-if="newUser" class="sm:mx-auto sm:w-full sm:max-w-md">
            <h2
                class="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900"
            >
                <!-- am here i need to solve this  -->
                Créer un compte pour générer un business plan
            </h2>
            <p class="mt-2 text-sm leading-5 text-center text-gray-600 max-w">
                ou
                <a
                    href="#"
                    @click="newUser = false"
                    class="font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-500 focus:outline-none focus:underline"
                    >Se connecter</a
                >
            </p>
        </div>

        <div v-else class="sm:mx-auto sm:w-full sm:max-w-md">
            <h2
                v-if="!forgetPassword"
                class="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900"
            >
                <!-- am here i need to solve this  -->
                Se connecter
            </h2>
            <h2
                v-else
                class="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900"
            >
                <!-- am here i need to solve this  -->
                Réinitialiser votre mot de passe
            </h2>
            <p
                v-if="!forgetPassword"
                class="mt-2 text-sm leading-5 text-center text-gray-600 max-w"
            >
                Ou
                <a
                    href="#"
                    @click="newUser = true"
                    class="font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-500 focus:outline-none focus:underline"
                    >Créer votre compte</a
                >
            </p>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
                <div v-if="newUser && !forgetPassword">
                    <label
                        for="name"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Nom
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                        <input
                            id="name"
                            type="text"
                            @blur="$v.name.$touch()"
                            :class="{
                                'border-red-500':
                                    $v.name.$dirty && $v.name.$error
                            }"
                            v-model="name"
                            required
                            class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        />
                    </div>
                    <p
                        v-if="$v.name.$dirty && $v.name.$error"
                        class="mt-2 ml-1 text-sm text-red-600"
                    >
                        {{
                            $v.name.required && !$v.name.minLength
                                ? "Nombre de caractère doit être supérieur à (3)!"
                                : ""
                        }}
                        {{ !$v.name.required ? "Le champ est requis!" : "" }}
                    </p>
                </div>
                <div class="mt-6" v-if="newUser && !forgetPassword">
                    <label
                        for="cin"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >CIN
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                        <input
                            id="cin"
                            type="text"
                            v-model="cin"
                            @blur="$v.cin.$touch()"
                            required
                            class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        />
                    </div>
                    <p
                        v-if="$v.cin.$dirty && $v.cin.$error"
                        class="mt-2 ml-1 text-sm text-red-600"
                    >
                        {{
                            $v.cin.required && !$v.cin.maxLength
                                ? "Nombre de caractère doit être inférieur a (10)!"
                                : ""
                        }}
                        {{ !$v.cin.required ? "Le champ est requis!" : "" }}
                    </p>
                </div>
                <div class="mt-6" v-if="newUser && !forgetPassword">
                    <label
                        for="email"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Numéro de téléphone
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                        <input
                            id="phoneNumber"
                            type="tel"
                            v-model="phoneNumber"
                            @blur="$v.phoneNumber.$touch()"
                            required
                            class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        />
                    </div>
                    <p
                        v-if="$v.phoneNumber.$dirty && $v.phoneNumber.$error"
                        class="mt-2 ml-1 text-sm text-red-600"
                    >
                        {{
                            $v.phoneNumber.required && !$v.phoneNumber.maxLength
                                ? "Nombre de caractère doit etre superieur a (9)!"
                                : ""
                        }}
                        {{
                            !$v.phoneNumber.required
                                ? "Le champ est requis!"
                                : ""
                        }}
                    </p>
                </div>
                <div class="mt-6">
                    <label
                        for="email"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Adresse email
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                        <input
                            id="email"
                            type="email"
                            v-model="email"
                            @blur="$v.email.$touch()"
                            required
                            class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        />
                    </div>
                    <p
                        v-if="$v.email.$dirty && $v.email.$error"
                        class="mt-2 ml-1 text-sm text-red-600"
                    >
                        {{
                            $v.email.required && !$v.email.email
                                ? "L'email est invalide!"
                                : ""
                        }}
                        {{ !$v.email.required ? "Le champ est requis!" : "" }}
                    </p>
                </div>

                <div class="mt-6" v-if="!forgetPassword">
                    <label
                        for="password"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Mot de passe</label
                    >
                    <div class="mt-1 rounded-md shadow-sm">
                        <input
                            id="password"
                            type="password"
                            v-model="password"
                            @blur="$v.password.$touch()"
                            required
                            class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                        />
                    </div>
                    <p
                        v-if="$v.password.$dirty && $v.password.$error"
                        class="mt-2 ml-1 text-sm text-red-600"
                    >
                        {{
                            $v.password.required && !$v.password.minLength
                                ? "Nombre de caractère doit etre superieur a (5)!"
                                : ""
                        }}
                        {{
                            !$v.password.required ? "Le champ est requis!" : ""
                        }}
                    </p>
                </div>

                <div
                    v-if="!newUser && !forgetPassword"
                    class="flex items-center justify-between mt-6"
                >
                    <div class="text-sm leading-5">
                        <a
                            @click="forgetPassword = true"
                            class="font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-500 focus:outline-none focus:underline"
                            >Mot de passe oublié?</a
                        >
                    </div>
                </div>
                <div
                    v-if="newUser"
                    class="flex items-center justify-between mt-6"
                >
                    <div class="text-sm leading-5">
                        <router-link
                            target="_blank"
                            :to="{ name: 'condition' }"
                            class="font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-500 focus:outline-none focus:underline"
                            >Conditions générales d'utilisation</router-link
                        >
                    </div>
                </div>

                <div class="mt-6">
                    <span class="block w-full rounded-md shadow-sm">
                        <button
                            id="submit"
                            :class="{ 'is-loading': isLoading }"
                            @click="signInOrCreateUser"
                            class="flex justify-center w-full px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700"
                        >
                            <span v-if="isLoading">
                                <svg
                                    class="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        class="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="4"
                                    ></circle>
                                    <path
                                        class="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                            </span>

                            {{
                                newUser
                                    ? "Créer un compte"
                                    : !forgetPassword
                                    ? "Se Connecter"
                                    : "Réinitialiser votre mot de passe"
                            }}
                        </button>
                    </span>
                    <p v-if="error" class="mt-2 ml-1 text-sm text-red-600">
                        {{ error }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { auth } from "@/services/firebase.service";
import {
    required,
    minLength,
    maxLength,
    alphaNum,
    email
} from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
    name: "rm",
    components: {},
    data() {
        return {
            auth,
            name: "",
            cin: "",
            phoneNumber: "",
            email: "",
            password: "",
            newUser: false,
            errorMessage: "",
            errorCode: "",
            isAnonymous: null,
            uid: null,
            data: null,
            forgetPassword: false
        };
    },
    created() {
        if (this.$route.query.inscription) {
            this.newUser = true;
        }

        const enterHandler = e => {
            if (e.key === "Enter") this.signInOrCreateUser();
        };
        document.addEventListener("keydown", enterHandler);
        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", enterHandler);
        });
    },
    validations() {
        if (this.newUser)
            return {
                name: {
                    required,
                    minLength: minLength(3)
                },
                cin: {
                    required,
                    maxLength: maxLength(10),
                    alphaNum
                },
                email: {
                    required,
                    email
                },
                phoneNumber: {
                    required,
                    minLength: minLength(9)
                },
                password: {
                    required,
                    minLength: minLength(6)
                }
            };
        return {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        };
    },
    methods: {
        signInOrCreateUser() {
            if (this.newUser) {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.$store
                        .dispatch("Auth/registerUserWithEmailAndPassword", {
                            name: this.name,
                            cin: this.cin,
                            email: this.email,
                            password: this.password,
                            phoneNumber: this.phoneNumber
                        })
                        .then(result => {
                            if (result === "success")
                                this.$router.push({
                                    name: "business_plan_version"
                                });
                        });
                }
            } else {
                if (!this.forgetPassword) {
                    this.$v.$touch();
                    if (!this.$v.$invalid) {
                        this.$store
                            .dispatch("Auth/signInWithEmailAndPassword", {
                                email: this.email,
                                password: this.password
                            })
                            .then(result => {
                                if (result === "success")
                                    this.$router.push(
                                        this.$route.query.redirectTo || "/"
                                    );
                            });
                    }
                } else {
                    auth.sendPasswordResetEmail(this.email)
                        .then(() => {
                            console.log("Email Sent");
                            this.$router.push({ name: "Home" });
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            }
        }
    },
    computed: {
        ...mapState("Auth", {
            isLoading: state => state.loading,
            error: state => state.error.message
        })
    }
};
</script>



